import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ConnectPZ.css';
/*flow-disable*/


const UserIsNotConnectedWithPZ = () =>
<div className={s.container}>
  <h3>Połącz swoje konto z profilem zaufanym.</h3>
  <p>Połączenie konta z profilem zaufanym umożliwia podpisywanie elektroniczne wygenerowanych dokumentów.</p>
  <p>Wygenerowany i podpisany dokument można wówczas wysłać bezpośrednio do urzędu.</p>
  <p>Połączenie konta z profile zaufanym jest czynnością jednorazową. Wystarczy tylko zalogwać się w profilu zaufanym.</p>
  <form method="post" action={process.env.LOGIN_ENDPOINT}>
    <div className={s.formGroup}>
      <button type="submit" className={s.facebook} href={process.env.LOGIN_ENDPOINT}>
        <span>Zaloguj przez Profil Zaufany</span>
      </button>
    </div>
  </form>
</div>;

const UserIsConnectedWithPZ = () =>
<div className={s.container}>
  Twoje konto zostało już połączone z Profilem zaufanym.
</div>;

class ConnectPZ extends React.Component {

  render() {

    return (
      <div className={s.root}>
        {this.props.user ? <UserIsNotConnectedWithPZ /> : <UserIsConnectedWithPZ />}
      </div>
    );
  }
}

export default withStyles(s)(ConnectPZ);


// WEBPACK FOOTER //
// src/routes/connectPZ/ConnectPZ.js